import $ from 'jquery';
import FJTextAnimationData from './FJTextAnimationData';
import FJStaticAnimation from './FJStaticAnimation';
import FJMathUtil from '../../util/FJMathUtil';
import FJArrayUtil from '../../util/FJArrayUtil';

function getAnimationTypes() {
    let types = {};
    for (let key in FJTextAnimationData) {
        types[key] = key.toString();
    }
    return types;
}

const ANIMATION_NAME = getAnimationTypes();

// 需要复制元素的特殊文字动画列表
const NEED_CLONE_ANIMATIONS = [
    ANIMATION_NAME.TEXT_ROLL_IN,
    ANIMATION_NAME.TEXT_ROLL_OUT,
    ANIMATION_NAME.TEXT_ROLL_SLOW_IN,
    ANIMATION_NAME.TEXT_NEWS_LEFT_LOOP,
];

// 需要修改整体动画层级dom overflow属性的特殊文字动画列表
const NEED_ALL_OVERFLOW_ANIMATIONS = [
    ANIMATION_NAME.TEXT_ROLL_IN,
    ANIMATION_NAME.TEXT_ROLL_OUT,
    ANIMATION_NAME.TEXT_ROLL_SLOW_IN,
    ANIMATION_NAME.TEXT_NEWS_LEFT_LOOP,
];

class FJTextAnimation extends FJStaticAnimation {
    constructor(props = {}) {
        const { animationTargets = [], options } = props;
        props.callbacks = {
            onBeforeUpdate: anime => {
                this._onBeforeUpdate(anime, animationTargets, options);
            },
            onUpdate: anime => {
                this._onUpdate(anime, animationTargets, options);
            },
            onComplete: anime => {
                this._onComplete(anime, animationTargets, options);
            },
        };

        super(props);

        this._animationTextAllTarget = props.animationTextAllTarget;
        this._animationMultipleTargets = props.animationMultipleTargets;
        this._animationSupportTarget = props.animationSupportTarget;
        this._textAllAnimationActive = props.textAllAnimationActive;
    }
    _onBeforeUpdate(anime, animationTargets, options = {}) {
        const currentTime = anime.currentTime;
        const animationName = this.getCurrentActiveAnimationName(currentTime);
        this._updateAnimationStyle(currentTime, animationTargets, {
            ...options,
            animationName,
            aniRealCurrentTime: anime._currentTime === undefined ? currentTime : anime._currentTime,
        });
        this.onUpdateLoopAnimationRender(currentTime);
    }

    //#region callbacks of timeline
    /**
     * @desc 初始化动画样式
     * @param {*} currentTime
     * @param {*} animationTargets
     * @param {*} options
     */
    _updateAnimationStyle = (currentTime, animationTargets, options = {}) => {
        const { animationName: currentAnimationName, aniRealCurrentTime } = options;

        // TODO： 特殊处理，BLOCK_OUT 的动画需要先清空之前动画的属性
        const BLOCK_OUT = ['BLOCK_OUT_LEFT', 'BLOCK_OUT_RIGHT', 'BLOCK_OUT_TOP', 'BLOCK_OUT_BOTTOM'];
        if (BLOCK_OUT.includes(currentAnimationName) || BLOCK_OUT.includes(this._activeAnimationName)) {
            const activeAnimationName = BLOCK_OUT.includes(currentAnimationName)
                ? currentAnimationName
                : this._activeAnimationName;
            const currentAnimationData = FJTextAnimationData[activeAnimationName];
            if (currentAnimationData && currentAnimationData.methods) {
                const { onDestroy } = currentAnimationData.methods;
                if (onDestroy) onDestroy(animationTargets);
            }
        }

        // 如果前后是不同的动画，则先清空之前动画的属性，再应用当前动画的初始必要属性
        const isStaticAnime = this._isStaticAnimeByTime && this._isStaticAnimeByTime(aniRealCurrentTime);
        !isStaticAnime && this._updateContainerForBegin(animationTargets, currentAnimationName, currentTime);
        if (this._activeAnimationName !== currentAnimationName || this._isStaticAnime !== isStaticAnime) {
            // TODO 这里最合适的处理应该是在 onBegin 但由于 onBegin 的绑定需要更改绑定对象，以及触发机制的不确定性，暂时先在这里处理
            this._clearAnime(animationTargets, this._activeAnimationName, currentTime);

            // TODO 这里isWholeAnimation 的判断是在非文字动画的请况下不应该触发文字动画的初始化，所以不进行处理
            !isStaticAnime && this._initAnimationStyle(animationTargets, currentAnimationName);
        }
        // TODO： 文字动画配合整体动画时，currentAnimationName 获取的本应该是整体动画，但这里实际只能获取到文字动画，
        // 导致特殊动画的样式无法清除，所以这里需要特殊处理 isStaticAnime = true  代表当前时间是整体动画
        // 这里不传 this._activeAnimationName 是因为动画更新结束后更新封面帧时，this._activeAnimationName 为空， 导致特殊动画的样式无法清除
        isStaticAnime && this._clearAnimationFromTargetMultipleDirection(currentAnimationName);

        // TODO: 初始化特殊动画的样式
        !isStaticAnime && this._initAnimationFromTargetMultipleDirection(currentAnimationName);

        this._activeAnimationName = currentAnimationName;
        this._isStaticAnime = isStaticAnime;
    };
    /**
     * @desc 主动画的onUpdate回调 用于处理总动画时长相关事件
     * @param {*} anime
     * @param {*} animationTargets
     * @param {*} options
     */
    _onUpdate = (anime, animationTargets, options = {}) => {};

    /**
     * @desc 主动画的onComplete回调 用于处理总动画时长相关事件
     * @param {*} anime
     * @param {*} animationTargets
     * @param {*} options
     */
    _onComplete = (anime, animationTargets, options = {}) => {
        // const currentTime = anime.currentTime;
        // console.log('onComplete', currentTime);
    };

    /**
     * @desc 子动画的onUpdate回调
     * @param {*} anime
     * @param {*} animationTargets
     * @param {*} options
     */
    _childOnUpdate = (anime, animationTargets, options = {}) => {
        const currentTime = anime.currentTime;
        const { animationName, forceProgress } = options;

        let showDuration = 0;
        let singleDuration = 0;
        this._animationTimeLines.forEach(item => {
            if (item.animationName === animationName) {
                showDuration = item.showDuration;
                singleDuration = item.singleDuration;
            }
        });
        // 使用 queueMicrotask animationjs的动画更新在onupdate之后，可能会把部分属性给重置
        const isIgnoreQueueMicrotask = FJTextAnimationData[animationName]?.isIgnoreQueueMicrotask;
        if (isIgnoreQueueMicrotask) {
            this._renderAnime(animationTargets, animationName, currentTime, {
                showDuration,
                singleDuration,
                progress: anime.progress,
                forceProgress,
            });
        } else {
            queueMicrotask(() =>
                this._renderAnime(animationTargets, animationName, currentTime, {
                    showDuration,
                    singleDuration,
                    progress: anime.progress,
                    forceProgress,
                }),
            );
        }
    };

    /**
     * @desc 子动画的onBeforeUpdate回调
     * @param {*} anime
     * @param {*} animationTargets
     * @param {*} options
     */
    _childOnBeforeUpdate = (anime, animationTargets, options = {}) => {
        const { animationName } = options;
        // TODO _updateStaticTargetsForPerFrame 中处理 clip-path 是因为 clip-path 是某些动画的过渡效果，需要每一帧都更新
        this._updateStaticTargetsForPerFrame(animationName, options.animationComposition);
    };

    _childOnComplete = (anime, animationTargets, options = {}) => {
        const { animationName } = options;
        this._clearAnimationFromTargetMultipleDirection(animationName);
    };

    /**
     * @desc 手动更新子动画的onUpdate回调， 主要处理anime seek 时间为0 不出发更新问题
     * @param {*} anime
     * @param {*} animationTargets
     * @param {*} options
     */
    _customUpdateChildOnUpdate = time => {
        const animeName = this.getCurrentActiveAnimationName(time);
        // 由于animejs的seek时间不会触发更新，所以手动设置 forceProgress 为 0  确保封面帧跟新
        this._childOnUpdate(this._animation, this._animationTargets, { animationName: animeName, forceProgress: 0 });
    };

    //#endregion

    //#region 渲染和清空特殊的动画样式
    _clearAnime(targets, beforeAnimationName, currentTime) {
        this._clearAnimationFromTarget(targets);
        // 之前的动画
        if (beforeAnimationName) {
            const beforeAnimationData = FJTextAnimationData[beforeAnimationName];
            const timeData = this._timeLineTimeData.getTimeDataByAnimationName(beforeAnimationName);
            const { startTime, duration } = timeData;
            let progress = (currentTime - startTime) / duration;
            progress = FJMathUtil.valueOfInterval(progress, 0, 1);
            if (beforeAnimationData && beforeAnimationData.methods) {
                const { onClear, render } = beforeAnimationData.methods;
                if (onClear) onClear(targets, { progress: progress * 100 });
                // TODO 字幕动画的清除存疑？暂时屏蔽
                if (beforeAnimationData.isSubtitleAnimation && progress === 100) {
                    // render(anime, {
                    //     wordTimestampList: options.isSubtitleAnimation ? options.wordTimestampList : [],
                    //     textColor: options.textColor,
                    //     isRenderEnd: true,
                    // });
                }
            }

            this._clearAnimationFromTargetMultipleDirection(beforeAnimationName);
        }
    }

    _renderAnime = (targets, animationName, currentTime, options = {}) => {
        const currentAnimationData = FJTextAnimationData[animationName];
        if (currentAnimationData && currentAnimationData.methods) {
            const { render, onClear } = currentAnimationData.methods;

            // const progress = this._convertTimeToProgressInAnime(currentTime, animationName);
            const { progress = 0, forceProgress } = options;
            if (render) {
                const timeData = this._timeLineTimeData.getTimeDataByAnimationName(animationName);
                const { options: animationOptions = {}, startTime } = timeData;
                const { wordTimestampList, textColor, animationTextColor, animationBackgroundColor } = {
                    ...animationOptions,
                };
                render(targets, {
                    currentTime: currentTime,
                    textColor: textColor,
                    wordTimestampList: wordTimestampList,
                    animationTextColor: animationTextColor,
                    animationBackgroundColor: animationBackgroundColor,
                    ...options,
                    progress: progress * 100,
                    forceProgress,
                });
            }

            if (progress >= 0.99 && onClear && currentAnimationData.isExit) {
                onClear(targets, { progress: progress * 100 });
            }
        }
    };
    //#endregion

    addAnimation(targets, animationName, duration = 1000, delay = 0, startTime = 0, endTime, options = {}) {
        if (!targets || !animationName) return false;

        let animationData = FJTextAnimationData[animationName];
        if (!animationData) return false;

        const { speed, isSubtitleAnimation, wordTimestampList, textColor, isTextEditMode, showDuration } = options;

        const { methods = {}, progressKey } = animationData;
        const { render, updateEffectDOM } = methods;

        // 如果有update方法，则在动画元素上添加上progress属性，并在animationData中添加进行范围
        if (render && progressKey) {
            animationData[animationData.progressKey] = [0, 1];
            targets.forEach(target => {
                target.setAttribute(animationData.progressKey, 0);
            });
        }

        if (updateEffectDOM) {
            targets = updateEffectDOM(targets, { color: textColor, isTextEditMode: isTextEditMode }) || targets;
        }

        const { singleAnimationDuration, singleTextDelay } = FJTextAnimation.getTextAnimationTimeData(
            animationName,
            targets,
            {
                speed,
                isSubtitleAnimation,
                duration,
            },
        );

        const animeDelay = this._getTextAnimationDelay(targets, animationData, singleTextDelay, {
            isSubtitleAnimation,
            wordTimestampList,
        });

        if (NEED_CLONE_ANIMATIONS.includes(animationName)) {
            return this._addTextAllAnimation(
                animationData,
                animationName,
                singleAnimationDuration,
                animeDelay,
                startTime,
                endTime,
                duration,
                options,
            );
        }

        return super.addAnimation(targets, animationName, singleAnimationDuration, animeDelay, startTime, endTime, {
            ...options,
            elementShowDuration: duration,
            singleDuration: singleAnimationDuration,
        });
    }

    /**
     * @desc 添加特殊文字整体动画
     * @returns
     */
    _addTextAllAnimation(
        animationData,
        animationName,
        singleAnimationDuration,
        animeDelay,
        startTime,
        endTime,
        duration,
        options = {},
    ) {
        if (!this._textAllAnimationActive) {
            return true;
        }
        const multipleDirection = animationData.multipleDirection || {};
        const eleTargets = this._animationMultipleTargets ? this._animationMultipleTargets() : null;

        Object.keys(multipleDirection).forEach(dir => {
            // 查询各个方向的DOM元素
            const eleTarget = eleTargets[dir];
            if (eleTarget) {
                super.addAnimation(
                    [eleTarget],
                    animationName,
                    singleAnimationDuration,
                    animeDelay,
                    startTime,
                    endTime,
                    {
                        ...options,
                        elementShowDuration: duration,
                        singleDuration: singleAnimationDuration,
                        childDirection: dir,
                    },
                );
            }
        });
        const supportTarget = this._animationSupportTarget;
        if (supportTarget) {
            super.addAnimation(
                [supportTarget],
                animationName,
                singleAnimationDuration,
                animeDelay,
                startTime,
                endTime,
                {
                    ...options,
                    elementShowDuration: duration,
                    singleDuration: singleAnimationDuration,
                },
            );
        }

        const target = this._animationTextAllTarget;

        if (target) {
            return super.addAnimation(
                [target],
                animationName,
                singleAnimationDuration,
                animeDelay,
                startTime,
                endTime,
                {
                    ...options,
                    elementShowDuration: duration,
                    singleDuration: singleAnimationDuration,
                },
            );
        }
        return false;
    }

    // 转换成该动画的进度,非整个动画时间线的进度，而是将动画时间线的时间，转换成该时间线上的动画的进度0-1
    // 比如进场退场各自一半，假如time刚好在时间线中间，则进场动画的进度为1，退场为0，整个动画时间线的进度为0.5
    _convertTimeToProgressInAnime = (time, animeName) => {
        // time 必须是整个动画时间线的时间
        const timeData = this._timeLineTimeData.getTimeDataByAnimationName(animeName);
        if (timeData) {
            const { startTime, duration } = timeData;
            let progress = (time - startTime) / duration;
            progress = FJMathUtil.valueOfInterval(progress, 0, 1);
            return progress;
        }
        return null;
    };
    // 获取文字动画的延迟func
    _getTextAnimationDelay(targets, animationData, singleTextDelay, options) {
        const { isSubtitleAnimation, wordTimestampList } = options;
        if (isSubtitleAnimation) {
            return (ele, i, l) => {
                const index = i || 0;
                return wordTimestampList[index].startTime * 1000 + (index === 0 ? 10 : 0);
            };
        } else if (typeof animationData.methods?.customDelay === 'function') {
            return (ele, i, l) => {
                return animationData.methods.customDelay(ele, i, l, { delay: singleTextDelay, targets });
            };
        } else if (typeof animationData.methods?.customDelay === 'number') {
            return animationData.methods.customDelay;
        } else if (animationData.disableDefaultDelayStagger) {
            return singleTextDelay;
        } else {
            return (ele, i, l) => {
                return i * singleTextDelay;
            };
        }
    }

    //#region 容器和文字的样式更新
    // 更新容器在动画开始前
    _updateContainerForBegin(targets = [], aniName, currentTime) {
        super._updateContainerForBegin(targets, aniName, currentTime);
        this.updateContainerOverflow(aniName, targets, currentTime);
    }
    // 更新文字动画的容器的overflow属性
    updateContainerOverflow(aniName, targets = [], currentTime) {
        if (this._isStaticAnimeByTime && currentTime !== undefined && this._isStaticAnimeByTime(currentTime)) {
            return;
        }
        const isWillChangeContainer = aniName ? this._isWillChangeScaleContainer(aniName) : false;
        const isWillBeClipContainer = aniName ? this._isWillBeClipContainer(aniName) : false;

        if (targets) {
            targets.forEach(target => {
                let clipContainerNode = null;
                if (target && target.parentNode) {
                    clipContainerNode = target.parentNode;
                }

                if (
                    clipContainerNode &&
                    clipContainerNode.parentNode &&
                    $(clipContainerNode.parentNode).hasClass('fl-text-overflow')
                ) {
                    clipContainerNode = clipContainerNode.parentNode;
                }

                clipContainerNode &&
                    $(clipContainerNode).css({
                        overflow: isWillBeClipContainer ? 'hidden' : 'visible',
                        willChange: isWillChangeContainer ? 'transform' : 'unset',
                    });
            });
        }

        if (NEED_ALL_OVERFLOW_ANIMATIONS.includes(aniName)) {
            this._animationContainer.style.overflow = isWillBeClipContainer ? 'hidden' : 'visible';
            this._animationContainer.style.willChange = isWillChangeContainer ? 'transform' : 'unset';
            return;
        }
        // animationTargetContainer 是整体动画中用来进行控制 overflow 和 willChange 的元素
        // 如果整体动画的是 clip 的，文字动画需要超出 clip 的范围则需要将 animationTargetContainer 的 overflow 设置为 visible
        // 否则会导致文字动画被 clip 裁剪
        if (!isWillBeClipContainer && this._animationContainer) {
            this._animationContainer.style.overflow = 'visible';
        }
    }
    // 特殊的动画的副作用业务代码
    _updateStaticTargetsForPerFrame = (aniName, animationComposition) => {
        if (!aniName || !animationComposition) return;

        const ANIME_LIST = ['SPREAD', 'FLY', 'CLARIFY', 'GLOW_BLUR', 'CONTRACT', 'REBOUND', 'SCALE_DOWN'];

        // TODO 应该进行通用处理
        if (ANIME_LIST.some(anim => aniName.includes(anim))) {
            animationComposition && (animationComposition.style['clip-path'] = 'initial');
        }
    };

    // 初始化动画样式
    _initAnimationStyle(targets, name) {
        const animationData = FJTextAnimationData[name];
        if (animationData?.methods?.initStyle) {
            animationData.methods.initStyle(targets);
        }
    }

    //#endregion

    /**
     * @override
     * @desc 重载创建动画数据的方法
     * @param animationName
     * @param options
     * @return {*}
     * @private
     */
    _createAnimationData(animationName, options) {
        const motionData = FJTextAnimationData[animationName];

        if (motionData && motionData.multipleDirection && options.childDirection) {
            return { ...motionData.multipleDirection[options.childDirection] };
        }

        return FJTextAnimationData[animationName];
    }

    /**
     * @override
     * @param animationName
     * @private
     */
    _isWillBeClipContainer(animationName) {
        let data = FJTextAnimationData[animationName];
        return data && (data.overflow === 'hidden' || data.options?.overflow === 'hidden');
    }

    /**
     * @override
     * @param animationName
     * @private
     */
    _isWillChangeScaleContainer(animationName) {
        let data = FJTextAnimationData[animationName];
        return (data && data.scale) || animationName === 'SCALE_UP_LOOP';
    }

    /**
     * @override
     * @desc 动画开始时更新style
     * @param targets
     * @param animationName
     */
    _updateTransformOrigin(targets, animationName) {
        if (!targets) return;
        let data = FJTextAnimationData[animationName];
        if (data && data.methods?.updateTransformOrigin) {
            data.methods.updateTransformOrigin(targets);
        } else {
            super._updateTransformOrigin(targets, animationName);
        }
    }

    /**
     * @desc 清空多个动画目标的样式
     * @param {string} beforeAnimationName - 之前的动画名字
     */
    _clearAnimationFromTargetMultipleDirection(beforeAnimationName) {
        if (!NEED_CLONE_ANIMATIONS.includes(beforeAnimationName)) return;

        const animationData = FJTextAnimationData[beforeAnimationName];
        if (animationData && animationData.multipleDirection) {
            const multipleTargetObjects = this._animationMultipleTargets ? this._animationMultipleTargets() : null;
            Object.keys(animationData.multipleDirection).forEach(dir => {
                const target = multipleTargetObjects[dir];
                if (target) {
                    target.style.display = 'none';
                }
            });
        }
    }

    _initAnimationFromTargetMultipleDirection(animationName) {
        if (!NEED_CLONE_ANIMATIONS.includes(animationName)) return;

        const animationData = FJTextAnimationData[animationName];

        if (animationData && animationData.multipleDirection) {
            const multipleTargetObjects = this._animationMultipleTargets ? this._animationMultipleTargets() : null;
            Object.keys(animationData.multipleDirection).forEach(dir => {
                const target = multipleTargetObjects[dir];
                if (target) {
                    target.style.display = 'block';
                }
            });
        }
    }

    // 准备从头开始播放，主要是开放给字幕动画使用
    prepareStartAnimation() {
        this._initAnimationStyle(this._animationTargets, this._animationInName);
    }

    // 获取一个文字的播放时长
    static getTextAnimationTimeData(animationName, targets, options) {
        const animationData = FJTextAnimationData[animationName];
        if (!animationData) return null;
        const { delayRate = 0, singleDuration } = animationData;

        const { speed, isSubtitleAnimation, duration } = options;
        let durationRate; // 时长比例
        if (speed) {
            // 获取一次动画的时长
            let duration1 = isSubtitleAnimation
                ? FJTextAnimation.getSubtitlePlayDuration(animationName, targets.length, speed)
                : FJTextAnimation.getPlayDuration(animationName, targets.length, speed, { targets });
            // 如果播放完一次的时长不够，则重新计算时长比例
            if (duration1 > duration) {
                durationRate = isSubtitleAnimation
                    ? FJTextAnimation.getSubtitleInDuration(animationName, targets.length, duration)
                    : FJTextAnimation.getSpeedInDuration(animationName, targets.length, duration, targets);
            } else {
                durationRate = 1 / speed;
            }
        } else {
            durationRate = FJTextAnimation.getSpeedInDuration(animationName, targets.length, duration, targets);
        }
        const singleAnimationDuration = singleDuration * durationRate;
        const delay = singleAnimationDuration * delayRate;
        return { singleAnimationDuration, singleTextDelay: delay };
    }

    /**
     * @desc 得到播放一次动画的时长
     * @param name - 动画名字
     * @param textLength - 文字长度
     * @param speed - 动画速度
     * @return {number} 如果为Infinity则表示是循环动画,单位ms
     */
    static getPlayDuration(name, textLength = 1, speed = 1, options = {}) {
        const animationData = FJTextAnimationData[name];
        if (!name || !animationData) return 0;

        const { singleDuration, delayRate, maxLength = Infinity, methods } = animationData;
        const { customGetPlayDuration } = methods;

        if (customGetPlayDuration && options.targets) {
            return customGetPlayDuration(options.targets, { singleDuration, delayRate, speed });
        } else {
            return (1 + delayRate * Math.min(textLength - 1, maxLength - 1)) * (singleDuration * (1 / speed));
        }
    }

    /**
     * @desc 得到播放一次字幕动画的时长
     * @param name - 动画名字
     * @param textLength - 文字长度
     * @param speed - 动画速度
     * @return {number} 如果为Infinity则表示是循环动画,单位ms
     */
    static getSubtitlePlayDuration(name, textLength = 1, speed = 1) {
        let animationData = FJTextAnimationData[name];
        if (!name || !animationData) return 0;

        let { singleDuration } = animationData;
        return (1 + Math.min(textLength - 1, Infinity - 1)) * (singleDuration * (1 / speed));
    }

    // 得到能完整播放一次的速度
    static getSpeedInDuration(name, textLength, duration, targets) {
        let animationData = FJTextAnimationData[name];
        if (!name || !animationData) return -1;
        let { singleDuration, delayRate, maxLength = Infinity, methods } = animationData;
        const { customGetSpeedInDuration } = methods;

        if (customGetSpeedInDuration && targets) {
            return customGetSpeedInDuration(targets, { singleDuration, delayRate, duration });
        } else {
            return duration / ((1 + delayRate * Math.min(textLength - 1, maxLength - 1)) * singleDuration);
        }
    }

    // 得到能完整播放一次的速度
    static getSubtitleInDuration(name, textLength, duration) {
        let animationData = FJTextAnimationData[name];
        if (!name || !animationData) return -1;
        let { singleDuration } = animationData;
        return duration / ((1 + Math.min(textLength - 1, Infinity - 1)) * singleDuration);
    }

    /**
     * @desc 是否是循环动画
     * @param name
     * @return {boolean}
     */
    static isLoopAnimation(name) {
        if (!name || !FJTextAnimationData[name]) return false;
        return Boolean(FJTextAnimationData[name].isLoop);
    }

    /**
     * @desc 是否是有效动画
     * @param name
     * @return {boolean}
     */
    static isEffectiveAnimation(name) {
        if (!name || !FJTextAnimationData[name]) return false;
        else return true;
    }

    /**
     * @desc 获取文字动画默认的文字组合方式
     * @param name
     * @return {string|string|*|string} character | word
     */
    static getTextCombinationType(name) {
        if (!name || !FJTextAnimationData[name]) return '';
        else return FJTextAnimationData[name].combinationType;
    }

    static getCoverFrameTime(name, textLength = 1, speed = 1, options = {}) {
        if (!name || !FJTextAnimationData[name]) return 0;
        const duration = FJTextAnimation.getPlayDuration(name, textLength, speed, options);
        const coverFrameRate = FJTextAnimationData[name].coverFrameRate;
        if (typeof coverFrameRate !== 'undefined') return duration * coverFrameRate;
        else return 0;
    }

    /**
     * @desc 跳转到某一时间点
     * @param {number} time - 时间，单位为毫秒
     */
    seek(time) {
        this.seekAnimation(this._animation, time);

        // 如果seek到0，不会触发更新方法，则需要手动触发
        let isSeekStart = time === 0;
        const animeTimeData = this._timeLineTimeData.getTimeDataInTime(time);

        if (animeTimeData) {
            isSeekStart = time === animeTimeData.startTime;
        }

        if (isSeekStart) {
            this._onBeforeUpdate({ currentTime: 0 }, this._animationTargets, {});
            this._onUpdate({ currentTime: 0 }, this._animationTargets, {});
            this._customUpdateChildOnUpdate(time);
        }
    }
}

export default FJTextAnimation;
export { ANIMATION_NAME, NEED_CLONE_ANIMATIONS, NEED_ALL_OVERFLOW_ANIMATIONS };
